// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dropdown-m__wrapper__3n-b7","select-wrapper":"dropdown-m__select-wrapper__2uKx_","label":"dropdown-m__label__25_R0"};